<template>
  <div class="row ml-2 mb-5" v-if="form.data.value_type">
    <div class="col-md-12 pt-4">
      <h4 class="card-title mb-2">Customer {{form.data._prerequisite_content === 'quantity' ? 'buys' : 'spends'}}</h4>
      <base-radio class="mb-2" name="quantity" value="quantity" v-model="form.data._prerequisite_content">
        Minimum quantity of items
      </base-radio>
      <base-radio class="mb-2" name="amount" value="amount" v-model="form.data._prerequisite_content">
        Minimum purchase amount
      </base-radio>
      <div class="row px-3 mt-3">
        <div class="col-md-2 px-0 pr-2">
          <h5>{{capitalize(form.data._prerequisite_content)}}</h5>
          <a-input v-if="form.data._prerequisite_content === 'quantity'" v-model="form.data.prerequisite_to_entitlement_quantity_ratio.prerequisite_quantity" input-classes="form-control" required :disabled="viewOnly" />
          <a-input v-else v-model="form.data.prerequisite_to_entitlement_purchase.prerequisite_amount" input-classes="form-control" required :disabled="viewOnly" />
        </div>
        <div class="col-md-10 px-0 pr-2">
          <h5>Any items from</h5>
          <a-select :options="type_options" style="width: 100%" v-model="form.data._prerequisite_type"></a-select>
        </div>
        <div class="col-12 pt-3 px-0 pr-2">
          <product-search-tab
            :form="form"
            :products="form.data.prerequisite_product_ids"
            :viewOnly="viewOnly"
            :tableElement="`buy-product-table`"
            :sales_channel_stores="form.sales_channel_stores"
          ></product-search-tab>
        </div>
      </div>
    </div>
    <div class="col-md-12 pt-4">
      <h4 class="card-title mb-2">Customer gets</h4>
      <div class="row px-3">
        <div class="col-md-2 px-0 pr-2">
          <h5>Quantity</h5>
          <a-input v-model="form.data.prerequisite_to_entitlement_quantity_ratio.entitled_quantity" input-classes="form-control" required :disabled="viewOnly" />
        </div>
        <div class="col-md-10 px-0 pr-2">
          <h5>Any items from</h5>
          <a-select :options="type_options" style="width: 100%" v-model="form.data._entitled_type"></a-select>
        </div>
        <div class="col-12 pt-3 px-0 pr-2">
          <product-search-tab
            :form="form"
            :products="form.data.entitled_product_ids"
            :viewOnly="viewOnly"
            :tableElement="`get-product-table`"
            :sales_channel_stores="form.sales_channel_stores"
          ></product-search-tab>
        </div>
      </div>
      <div class="row px-3">
        <div class="col px-0 pr-2">
          <h5>At a discounted value</h5>
          <a-input v-model="form.data.value" input-classes="form-control" style="margin-top: 5px;" placeholder="Discount percentage" required :disabled="viewOnly" />
          <small>Set value to 100 for free item/s</small>
        </div>
      </div>
    </div>
    <div class="col-md-12 pt-4">
      <h4 class="card-title mb-2">Usage limits</h4>
      <base-checkbox class="mb-2" :value="true" v-model="form.data._allocation_limit">
        Limit number of times this discount can be used per order
        <a-input v-if="form.data._allocation_limit" v-model="form.data.allocation_limit" input-classes="form-control" style="margin-top: 5px;" placeholder="Usage limit" required :disabled="viewOnly" />
      </base-checkbox>
      <base-checkbox class="mb-2" :value="true" v-model="form.data._usage_limit">
        Limit number of times this discount can be used in total
        <a-input v-if="form.data._usage_limit" v-model="form.data.usage_limit" input-classes="form-control" style="margin-top: 5px;" placeholder="Usage limit" required :disabled="viewOnly" />
      </base-checkbox>
      <base-checkbox class="mb-2" :value="true" v-model="form.data.once_per_customer">
        Limit to one use per customer
      </base-checkbox>
    </div>
    <div class="d-none">{{validationErrors}}</div>
  </div>
  <div v-else></div>
</template>
<script>
  import ProductSearchTab from './ProductSearchTab'

  export default {
    props: {
      form: Object,
      promotion: Object,
      viewOnly: Boolean
    },
    components: {
      ProductSearchTab
    },
    name: "buy-get-discount",
    data() {
      return {
        type_options: [
          {label: 'Products', value: 'products', disabled: false},
          {label: 'Collections', value: 'collections', disabled: true}
        ]
      }
    },
    methods: {
      capitalize: function(string) {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
      },
      validatePromotion: function(){
        let errors = []
        let data = this.form.data
        this.form.data.validationErrors = []
        data.prerequisite_to_entitlement_purchase = data.prerequisite_to_entitlement_purchase || {}
        data.prerequisite_to_entitlement_quantity_ratio = data.prerequisite_to_entitlement_quantity_ratio || {}

        data.prerequisite_to_entitlement_purchase.prerequisite_amount = parseFloat(data.prerequisite_to_entitlement_purchase.prerequisite_amount)
        data.prerequisite_to_entitlement_quantity_ratio.prerequisite_quantity = parseInt(data.prerequisite_to_entitlement_quantity_ratio.prerequisite_quantity)
        data.prerequisite_to_entitlement_quantity_ratio.entitled_quantity = parseInt(data.prerequisite_to_entitlement_quantity_ratio.entitled_quantity)
        data.value = data.value ? parseFloat(data.value) : 0

        if(data.value <= 0)
          errors.push('Discount percentage must be greater than 0')
        if(data.value > 100)
          errors.push('Discount percentage must not be greater than 100')
        if(data._prerequisite_content === 'quantity' && data.prerequisite_to_entitlement_quantity_ratio.prerequisite_quantity === 0)
          errors.push("Buy quantity must be greater than 0")
        if(data._prerequisite_content === 'amount' && data.prerequisite_to_entitlement_quantity_ratio.entitled_quantity === 0)
          errors.push("Buy amount must be greater than 0")
        if(data.prerequisite_to_entitlement_quantity_ratio.entitled_quantity === 0)
          errors.push("Get item quantity must be greater than 0")
        if(data.entitled_product_ids.length === 0)
          errors.push('Buy products must be added')
        if(data.prerequisite_product_ids.length === 0)
          errors.push('Get products must be added')
        if(data._usage_limit){
          data.usage_limit = data.usage_limit ? parseInt(data.usage_limit) : 0
          if(data.usage_limit <= 0)
            errors.push('Usage limit must be greater than 0')
        }

        this.form.data.validationErrors = errors
        return errors
      }
    },
    computed: {
      validationErrors: function () {
        return this.validatePromotion()
      }
    },
    mounted: function(){
      let starts_at = new Date()
      let ends_at = new Date()
      ends_at = new Date(ends_at.setMonth(ends_at.getMonth() + 1))
      this.form.data = {
        ...{
          title: this.form.code,
          value_type: 'percentage',
          _value: false,
          value: 0,
          target_type: 'line_item',
          target_selection: 'entitled',
          allocation_method: 'each',
          customer_selection: 'all',
          entitled_product_ids: [],
          prerequisite_product_ids: [],
          _prerequisite_content: 'quantity',
          _prerequisite_type: 'products',
          _entitled_type: 'products',
          prerequisite_to_entitlement_quantity_ratio:{
            prerequisite_quantity: 0,
            entitled_quantity: 0
          },
          prerequisite_to_entitlement_purchase:{
            prerequisite_amount: 0
          },
          _allocation_limit: false,
          allocation_limit: null,
          _usage_limit: false,
          usage_limit: null,
          once_per_customer: false,
          starts_at: starts_at.toDateString(),
          ends_at: ends_at.toDateString(),
          _ends_at: true,
          validationErrors: []
        },
        ...this.form.data
      }
    }
  }
</script>
